import api from "..";
import API_ENDPOINTS from "../endpoints";

export const getAthletePostById = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.ATHLETE_POST_BY_ID,
    params: {
      post_id: data.post_id,
    },
  });

  return response.data;
};
export const getAthleteHighlightById = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.ATHLETE_HIGHLIGHT_BY_ID,
    params: {
      h_id: data.h_id,
    },
  });

  return response.data;
};
